<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="medicalCheckData" (change)="medicalCheckChange()" (submit)="medicalCheckSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "MEDICAL_CHECK_TITLE" | translate | titlecase }}</h6>
            </div>





        </div>
        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3">


                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row justify-content-center">
                            <!-- <h5 class="font-bold m-0">{{(globals.lang == 'en')? candNameEn:candNameAr}} - {{candCode}} -
                                {{candNatId}}</h5> -->
                            <div class="img-with-text">
                                <!-- <img src="assets/images/stud-image.png" class="img-fluid" width="100" id="userImageTag"> -->
                                <img src="{{ photoPath}}" onerror="this.src ='assets/images/stud-image.png';"
                                    alt="Photo" class="img-fluid" width="100" id="userImageTag">
                                <p style="font-weight: bold;font-size: 16px">
                                    {{"CANDIDATE_NAME" | translate | titlecase}}: &nbsp; &nbsp;{{((globals.lang ==
                                    'en')? candNameEn:candNameAr)}} <br /><br />
                                    {{"CANDUDATE_CODE" | translate | titlecase}}: &nbsp; &nbsp; {{ candCode}}
                                    <br /><br />
                                    {{"NATIONAL_ID" | translate | titlecase}}: &nbsp; &nbsp;{{ candNatId}}<br /><br />
                                </p>
                            </div>
                        </div>
                        <br>
                        <div class="row">

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MEDICAL_CHECK_DATE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="" formControlName="medicalDate" readonly>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MEDICAL_CHECK_COMMENT" | translate | titlecase }}</label>
                                <input type="text" class="form-control"
                                    placeholder="{{ 'MEDICAL_CHECK_COMMENT' | translate | titlecase }}"
                                    formControlName="medicalInterviewComment">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="medicalCheckData.controls.medicalInterviewComment.touched && medicalCheckData.controls.medicalInterviewComment.invalid && medicalCheckData.dirty">
                                    {{ "PLEASE_ENTER_AVAILD_MEDICAL_COMMENT" | translate | titlecase }}
                                </div>
                            </div>
                        </div>


                        <div class="row">

                            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-start"
                                style="margin-left: 25px">

                                <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal"
                                    data-target="#ChronicDiseases"><i class="fas fa"></i>
                                    {{ "CHRONIC_DISEASES" | translate | titlecase }}</button>
                            </div>

                        </div>
                        <br /><br />
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MEDICAL_CHECK_STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="medicalCheckStatus">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="Medically Fit">{{ "MEDICAL_STATUS_VALUE_1" | translate | titlecase }}
                                    </option>
                                    <option value="Medically Unfit">
                                        {{ "MEDICAL_STATUS_VALUE_2" | translate | titlecase }}</option>
                                    <option value="Needs Medical Accommodation">
                                        {{ "MEDICAL_STATUS_VALUE_3" | translate | titlecase }}</option>
                                    <option value="Medical Check not done">
                                        {{ "MEDICAL_STATUS_VALUE_4" | translate | titlecase }}</option>
                                    <!-- <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                        }}</option> -->
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="medicalCheckData.controls.medicalCheckStatus.touched && medicalCheckData.controls.medicalCheckStatus.invalid && medicalCheckData.dirty">
                                    <!-- {{"PLEASE_SELECT_A_COUNTRY" | translate | titlecase}} -->
                                    {{ "PLEASE_SELECT_MEDICAL_STATUS" | translate | titlecase }}
                                </div>
                            </div>


                        </div>
                        <div class="row">
                            <div class="col-md-12 d-flex flex-wrap justify-content-left justify-content-lg-end">
                                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0"
                                    routerLink="/admission/candidate-inquiry" *ngIf="!creating">
                                    {{ "CANCEL" | translate | titlecase }}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - MEDICAL-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{ "SAVE" | translate | titlecase }}</button>
                                <app-loader [show]="creating"></app-loader>
                            </div>
                        </div>





                    </div>
                </div>
            </div>
        </div>



    </form>
</div>
<!-- Modal DisableServiceData-->
<div class="modal fade" id="ChronicDiseases" tabindex="-1" aria-labelledby="ChronicDiseases" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="medicalCheckDataPopUp" (submit)="chronicDiseases()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "SELECT_CHRONIC_DISESES" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">

                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="text-bold">{{ "CHRONIC_DISEASES" | translate | titlecase }}.</label>
                        <select class="custom-select" formControlName="medicalName1">
                            <option value="">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let res of chronicDiseases1" [ngValue]="res.id">{{
                                (globals.lang == 'ar')? res.diseaseDescAr : res.diseaseDescEn
                                }}</option>
                        </select>
                        <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="ServiceData.controls.serviceName.touched && ServiceData.controls.serviceName.invalid && ServiceData.dirty">
                                    Please Select Service Name
                                </div> -->
                    </div>

                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="comment1">
                        <!-- <div class="alert alert-danger py-1 mt-1"
                            *ngIf="medicalCheckData.controls.medicalInterviewComment.touched && medicalCheckData.controls.medicalInterviewComment.invalid && medicalCheckData.dirty">
                            Please enter a  Medical Check Comment
                        </div> -->
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="text-bold">{{ "CHRONIC_DISEASES" | translate | titlecase }}.</label>
                        <select class="custom-select" formControlName="medicalName2">
                            <option value="">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let res of chronicDiseases2" [ngValue]="res.id">{{
                                (globals.lang == 'ar')? res.diseaseDescAr : res.diseaseDescEn
                                }}</option>
                        </select>
                        <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="ServiceData.controls.serviceName.touched && ServiceData.controls.serviceName.invalid && ServiceData.dirty">
                                    Please Select Service Name
                                </div> -->
                    </div>

                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                        <input type="text" class="form-control" placeholder="" formControlName="comment2">
                        <!-- <div class="alert alert-danger py-1 mt-1"
                            *ngIf="medicalCheckData.controls.medicalInterviewComment.touched && medicalCheckData.controls.medicalInterviewComment.invalid && medicalCheckData.dirty">
                            Please enter a  Medical Check Comment
                        </div> -->
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="text-bold">{{ "CHRONIC_DISEASES" | translate | titlecase }}.</label>
                        <select class="custom-select" formControlName="medicalName3">
                            <option value="">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let res of chronicDiseases3" [ngValue]="res.id">{{
                                (globals.lang == 'ar')? res.diseaseDescAr : res.diseaseDescEn
                                }}</option>
                        </select>
                        <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="ServiceData.controls.serviceName.touched && ServiceData.controls.serviceName.invalid && ServiceData.dirty">
                                    Please Select Service Name
                                </div> -->
                    </div>

                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                        <input type="text" class="form-control" placeholder="" formControlName="comment3">
                        <!-- <div class="alert alert-danger py-1 mt-1"
                            *ngIf="medicalCheckData.controls.medicalInterviewComment.touched && medicalCheckData.controls.medicalInterviewComment.invalid && medicalCheckData.dirty">
                            Please enter a  Medical Check Comment
                        </div> -->
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="text-bold">{{ "CHRONIC_DISEASES" | translate | titlecase }}.</label>
                        <select class="custom-select" formControlName="medicalName4">
                            <option value="">{{ "SELECT" | translate | titlecase }}</option>
                            <option *ngFor="let res of chronicDiseases4" [ngValue]="res.id">{{
                                (globals.lang == 'ar')? res.diseaseDescAr : res.diseaseDescEn
                                }}</option>
                        </select>
                        <!-- <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="ServiceData.controls.serviceName.touched && ServiceData.controls.serviceName.invalid && ServiceData.dirty">
                                    Please Select Service Name
                                </div> -->
                    </div>

                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                        <input type="text" class="form-control" placeholder="" formControlName="comment4">
                        <!-- <div class="alert alert-danger py-1 mt-1"
                            *ngIf="medicalCheckData.controls.medicalInterviewComment.touched && medicalCheckData.controls.medicalInterviewComment.invalid && medicalCheckData.dirty">
                            Please enter a  Medical Check Comment
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-ChronicDiseases" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>
<app-loader [attr.show]="showLoader"></app-loader>